import { Language } from '../types';

/**
 * Application Configuration
 * 
 * This file contains global configuration settings for the Didohurtownia E-commerce application.
 * You can modify these settings to customize the application behavior.
 */

export const APP_CONFIG = {
  /**
   * Default Language
   * 
   * Sets the initial language for the application.
   * Supported values: 'en' (English) or 'pl' (Polish)
   * 
   * Users can still change the language using the language switcher in the UI.
   */
  defaultLanguage: 'pl' as Language,

  /**
   * Store Settings
   */
  store: {
    // Minimum quantity required for batch orders
    minQuantity: 6,
    
    // VAT rate (as decimal, e.g., 0.23 = 23%)
    vatRate: 0.23,
    
    // Currency
    currency: 'PLN',
    currencySymbol: 'zł',
  },

  /**
   * Feature Flags
   */
  features: {
    // Enable/disable backend API integration
    useBackendApi: true,
    
    // Enable/disable search functionality
    enableSearch: true,
    
    // Enable/disable cart functionality
    enableCart: true,
    
    // Show product stock levels
    showStock: true,
    
    // Enable product discounts
    enableDiscounts: true,
  },

  /**
   * UI Settings
   */
  ui: {
    // Number of featured products to show on homepage
    featuredProductsCount: 4,
    
    // Products per page in category view
    productsPerPage: 12,
    
    // Enable dark mode support (future feature)
    darkModeEnabled: false,
  },

  /**
   * Local Storage Keys
   */
  storage: {
    languageKey: 'didohurtownia-language',
    cartKey: 'didohurtownia-cart',
    themeKey: 'didohurtownia-theme',
  },
};

/**
 * Get the default language from config
 */
export const getDefaultLanguage = (): Language => {
  // First check if language is saved in localStorage
  const savedLanguage = localStorage.getItem(APP_CONFIG.storage.languageKey);
  if (savedLanguage && (savedLanguage === 'en' || savedLanguage === 'pl')) {
    return savedLanguage as Language;
  }
  // Otherwise return the configured default
  return APP_CONFIG.defaultLanguage;
};

/**
 * Save language preference to localStorage
 */
export const saveLanguagePreference = (language: Language): void => {
  localStorage.setItem(APP_CONFIG.storage.languageKey, language);
};
